<template>
  <el-dialog
    title="变更渠道"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
    @close="handleClose"
  >
    <el-form
      ref="channelForm"
      :model="form"
      :rules="rules"
      label-width="100px"
      v-loading="loading"
    >
      <el-form-item label="当前渠道：">
        <el-input
          v-model="currentChannel"
          disabled
        ></el-input>
      </el-form-item>
      
      <el-form-item label="新渠道：" prop="newChannel">
        <el-select
          v-model="form.newChannel"
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键字搜索"
          :remote-method="getChannelList"
          :loading="channelLoading"
          style="width: 100%"
          @change="handleChannelChange"
        >
          <el-option
            v-for="item in channelOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getChannelList, changeHyxUserChannel } from '@/api/member'

export default {
  name: 'ChangeChannel',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      default: ''
    },
    currentChannelName: {
      type: String,
      default: ''
    },
    currentChannelAlias: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      loading: false,
      channelLoading: false,
      submitting: false,
      form: {
        newChannel: ''
      },
      rules: {
        newChannel: [
          { required: true, message: '请选择新渠道', trigger: 'change' }
        ]
      },
      channelOptions: [],
      allChannels: []
    }
  },
  computed: {
    currentChannel() {
      if (this.currentChannelName && this.currentChannelAlias) {
        return `${this.currentChannelName}(${this.currentChannelAlias})`
      } else if (this.currentChannelAlias) {
        return this.currentChannelAlias
      } else {
        return '无'
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initData()
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    async initData() {
      this.form.newChannel = ''
      // 初始化时加载所有渠道
      await this.getChannelList()
    },
    async getChannelList(query) {
      try {
        this.channelLoading = true
        const res = await getChannelList()
        if (res.err_code === 0) {
          this.allChannels = res.rows || []
          
          // 处理搜索逻辑
          if (query !== undefined && query !== null && query.trim() !== '') {
            // 如果有查询关键词，进行过滤
            this.channelOptions = (res.rows || []).map(item => ({
              value: item.id.toString(),
              label: item.realname ? `${item.realname}(${item.alias})` : item.alias
            })).filter(item => 
              item.label.toLowerCase().includes(query.toLowerCase())
            )
          } else {
            // 如果没有查询关键词，显示所有渠道
            this.channelOptions = (res.rows || []).map(item => ({
              value: item.id.toString(),
              label: item.realname ? `${item.realname}(${item.alias})` : item.alias
            }))
          }
        }
      } catch (error) {
        console.error('获取渠道列表失败:', error)
        this.$message.error('获取渠道列表失败')
      } finally {
        this.channelLoading = false
      }
    },
    handleChannelChange(val) {
      this.form.newChannel = val
    },
    handleSubmit() {
      this.$refs.channelForm.validate(async valid => {
        if (!valid) return
        
        // 检查是否选择了有效的渠道
        if (!this.form.newChannel) {
          this.$message.warning('请选择新渠道')
          return
        }
        
        this.submitting = true
        try {
          // 调用变更渠道API接口
          const params = {
            id: this.userId,
            channel_id: parseInt(this.form.newChannel)
          }
          
          const res = await changeHyxUserChannel(params)
          if (res.err_code === 0) {
            this.$message.success('渠道变更成功')
            this.$emit('success')
            this.handleClose()
          } else {
            this.$message.error('渠道变更失败: ' + res.err_msg)
          }
        } catch (error) {
          console.error('渠道变更失败:', error)
          this.$message.error('渠道变更失败')
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}
</style>